<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Vsako poslano SMS sporočilo se obračuna po veljavnem ceniku in se zaračuna številki,
          s katere je bilo poslano. Sporočilo lahko hkrati pošljete <b> {{ maxSteviloPrejemnikov }} </b> prejemnikom.
          Za pošiljanje SMS sporočil je potrebno imeti vklopljeno dvostopenjsko zaščito, ki jo vklopite v meniju
          <a href="/Mojprofil/Varnost" class="modra-barva-info" target="_blank">
            <b>UREDI T-2 ID / VARNOST</b>
          </a>.
        </p>
      </div>
      <div style="clear: both"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaPosiljanjeSms',
  props: {
    maxSteviloPrejemnikov: null
  }
}
</script>

<style scoped>
.info-okvir {
  width: 660px;
  height: 130px;
  display: flex;
}

@media only screen and (max-width: 1300px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms/InfoKomponentaPosiljanjeSms.vue